function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import PropTypes from 'prop-types';
import isFunction from 'lodash/isFunction';
import remove from 'lodash/remove';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { setHOCDisplayName } from '@domain-group/fe-helper';
import { jsx as ___EmotionJSX } from "@emotion/core";
var allhomesGlobalObserver = function allhomesGlobalObserver(BaseComponent) {
  var ComponentWithObserver = /*#__PURE__*/function (_React$Component) {
    _inherits(ComponentWithObserver, _React$Component);
    var _super = _createSuper(ComponentWithObserver);
    function ComponentWithObserver() {
      var _this;
      _classCallCheck(this, ComponentWithObserver);
      for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
        _args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(_args));
      _defineProperty(_assertThisInitialized(_this), "_initialiseSubject", function (subject, command) {
        if (typeof window !== 'undefined') {
          var containerName = _this.props.containerName;
          window[containerName] = window[containerName] || {};
          window[containerName][subject] = window[containerName][subject] || [];
          _this.subjectContainer = window[containerName];
          if (isFunction(command)) {
            command();
          }
        }
      });
      _defineProperty(_assertThisInitialized(_this), "subscribeObserver", function (subject, observer) {
        _this._initialiseSubject(subject, function () {
          _this.subjectContainer[subject].push(observer);
        });
      });
      _defineProperty(_assertThisInitialized(_this), "unsubscribeObserver", function (subject, observer) {
        _this._initialiseSubject(subject, function () {
          remove(_this.subjectContainer[subject], function (value) {
            return value === observer;
          });
        });
      });
      _defineProperty(_assertThisInitialized(_this), "notifyObservers", function (subject) {
        for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          args[_key2 - 1] = arguments[_key2];
        }
        _this._initialiseSubject(subject, function () {
          _this.subjectContainer[subject].forEach(function (observer) {
            if (isFunction(observer)) {
              observer.apply(void 0, args);
            }
          });
        });
      });
      return _this;
    }
    _createClass(ComponentWithObserver, [{
      key: "render",
      value: function render() {
        return ___EmotionJSX(BaseComponent, _extends({
          subscribeObserver: this.subscribeObserver,
          unsubscribeObserver: this.unsubscribeObserver,
          notifyObservers: this.notifyObservers
        }, this.props));
      }
    }]);
    return ComponentWithObserver;
  }(React.Component);
  ComponentWithObserver.propTypes = {
    containerName: PropTypes.string
  };
  ComponentWithObserver.defaultProps = {
    containerName: '_allhomesGlobalObserverSubjectContainer'
  };
  setHOCDisplayName(ComponentWithObserver, BaseComponent, 'allhomesGlobalObserver');
  return hoistNonReactStatics(ComponentWithObserver, BaseComponent);
};
export default allhomesGlobalObserver;